module.exports = __webpack_public_path__ + "dde9cd2ce84cf38f8ab050fc88f1f472.svg";